import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  mergeUrlParams(event) {
    const form = event.target;
    const formUrl = new URL(form.action);
    const browserParams = new URLSearchParams(window.location.search);

    browserParams.forEach((value, key) => {
      if (!formUrl.searchParams.has(key)) {
        formUrl.searchParams.set(key, value);
      }
    });

    form.action = formUrl.toString();
  }
}
